export { SmileyHappy1 } from "./SmileyHappy1";
